"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWeeklyData = exports.ChartRangeDropdownPickerProvider = exports.useDispatchContext = exports.useStateContext = exports.useChartRangeDropdownPicker = exports.reducer = void 0;
var React = require("react");
var utils_1 = require("./utils");
var StateContext = React.createContext(undefined);
var DispatchContext = React.createContext(undefined);
var PropsContext = React.createContext(undefined);
function reducer(state, action) {
    var _a, _b;
    switch (action.type) {
        case "openDropdown":
            return __assign(__assign({}, state), { isDropdownOpen: true });
        case "closeDropdown":
            return __assign(__assign({}, state), { isDropdownOpen: false });
        case "cancel":
            // reset the state back to the beginning.
            return __assign({}, state.reset());
        case "changeCompareDateFlag": {
            // if I don't have the same dates. then make them the same as the ones I have
            var compareRangeFrom = state.compareRangeFrom ? state.compareRangeFrom : state.dateRangeFrom;
            var compareRangeTo = state.compareRangeTo ? state.compareRangeTo : state.dateRangeTo;
            return __assign(__assign({}, state), { hasCompareRange: action.value, compareRangeFrom: compareRangeFrom, compareRangeTo: compareRangeTo });
        }
        case "dateYearChange":
            // we have changed the year so set the date to be week 1 of the new year
            switch (action.which) {
                case "From":
                    var changeToDate = ((_a = state.dateRangeTo) === null || _a === void 0 ? void 0 : _a.year) <= action.year;
                    var dateRangeTo = changeToDate ? actionYearChange(state, action.year) : state.dateRangeTo;
                    // set MinSelectableDateNumber to 0 so that 'To' dropdown selections are enabled.
                    return __assign(__assign({}, state), { dateMinSelectableDateNumber: 0, dateRangeFrom: actionYearChange(state, action.year), dateRangeTo: dateRangeTo });
                case "To": {
                    if (action.year === state.dateRangeFrom.year) {
                        return __assign(__assign({}, state), { dateMinSelectableDateNumber: state.dateRangeFrom.value.EndDate.valueOf(), dateRangeTo: actionYearChange(state, action.year, state.dateRangeFrom.value) });
                    }
                    return __assign(__assign({}, state), { dateMinSelectableDateNumber: 0, dateRangeTo: actionYearChange(state, action.year) });
                }
            }
        case "dateWeekChange":
            switch (action.which) {
                case "From": {
                    var changeToDate = ChangeToDate(state.dateRangeTo.value, state.dateRangeFrom.value, action.which, action.item);
                    var dateRangeFrom = __assign(__assign({}, state.dateRangeFrom), { value: action.item });
                    var dateRangeTo = changeToDate ? dateRangeFrom : state.dateRangeTo;
                    return __assign(__assign({}, state), { 
                        // if not in the same year, activate all selections
                        dateMinSelectableDateNumber: state.dateRangeFrom.year === state.dateRangeTo.year ? action.item.EndDate.valueOf() : 0, dateRangeFrom: dateRangeFrom,
                        dateRangeTo: dateRangeTo });
                }
                case "To": {
                    if (ChangeToDate(state.dateRangeTo.value, state.dateRangeFrom.value, action.which, action.item)) {
                        return __assign(__assign({}, state), { dateRangeTo: __assign(__assign({}, state.dateRangeTo), { value: action.item }) });
                    }
                    return state;
                }
            }
        case "dateWeekSearch":
            switch (action.which) {
                case "From": return __assign(__assign({}, state), { dateRangeFrom: __assign(__assign({}, state.dateRangeFrom), actionWeeklyDataSearch(state, state.dateRangeFrom, action.search)) });
                case "To": return __assign(__assign({}, state), { dateRangeTo: __assign(__assign({}, state.dateRangeTo), actionWeeklyDataSearch(state, state.dateRangeTo, action.search)) });
            }
        case "compareYearChange":
            switch (action.which) {
                case "From":
                    var changeToDate = ((_b = state.compareRangeTo) === null || _b === void 0 ? void 0 : _b.year) <= action.year;
                    var compareRangeTo = changeToDate ? actionYearChange(state, action.year) : state.compareRangeTo;
                    // set MinSelectableDateNumber to 0 so that 'To' dropdown selections are enabled.
                    return __assign(__assign({}, state), { compareMinSelectableDateNumber: 0, compareRangeFrom: actionYearChange(state, action.year), compareRangeTo: compareRangeTo });
                case "To":
                    if (action.year === state.compareRangeFrom.year) {
                        return __assign(__assign({}, state), { compareMinSelectableDateNumber: state.compareRangeFrom.value.EndDate.valueOf(), compareRangeTo: actionYearChange(state, action.year, state.compareRangeFrom.value) });
                    }
                    return __assign(__assign({}, state), { compareMinSelectableDateNumber: 0, compareRangeTo: actionYearChange(state, action.year) });
            }
        case "compareWeekChange": {
            switch (action.which) {
                case "From": {
                    var changeToDate = ChangeToDate(state.compareRangeTo.value, state.compareRangeFrom.value, action.which, action.item);
                    var compareRangeFrom = __assign(__assign({}, state.compareRangeFrom), { value: action.item });
                    var compareRangeTo = changeToDate ? compareRangeFrom : state.compareRangeTo;
                    return __assign(__assign({}, state), { 
                        // if not in the same year, activate all selections
                        compareMinSelectableDateNumber: state.compareRangeFrom.year === state.compareRangeTo.year ? action.item.EndDate.valueOf() : 0, compareRangeFrom: compareRangeFrom,
                        compareRangeTo: compareRangeTo });
                }
                case "To": {
                    if (ChangeToDate(state.compareRangeTo.value, state.compareRangeFrom.value, action.which, action.item)) {
                        return __assign(__assign({}, state), { compareRangeTo: __assign(__assign({}, state.compareRangeTo), { value: action.item }) });
                    }
                    return state;
                }
            }
        }
        case "compareWeekSearch":
            switch (action.which) {
                case "From": return __assign(__assign({}, state), { compareRangeFrom: __assign(__assign({}, state.compareRangeFrom), actionWeeklyDataSearch(state, state.compareRangeFrom, action.search)) });
                case "To": return __assign(__assign({}, state), { compareRangeTo: __assign(__assign({}, state.compareRangeTo), actionWeeklyDataSearch(state, state.compareRangeTo, action.search)) });
            }
        default:
            return state;
    }
}
exports.reducer = reducer;
var useChartRangeDropdownPicker = function () { return React.useContext(PropsContext); };
exports.useChartRangeDropdownPicker = useChartRangeDropdownPicker;
var useStateContext = function () { return React.useContext(StateContext); };
exports.useStateContext = useStateContext;
var useDispatchContext = function () { return React.useContext(DispatchContext); };
exports.useDispatchContext = useDispatchContext;
var ChartRangeDropdownPickerProvider = function (_a) {
    var children = _a.children, value = _a.value;
    var AvailableDates = value.AvailableDates, DateRange = value.DateRange, CompareRange = value.CompareRange;
    var init = function () { return ({
        isDropdownOpen: false,
        dateRangeFrom: buildWeeklyData(AvailableDates, DateRange.From),
        dateRangeTo: buildWeeklyData(AvailableDates, DateRange.To, DateRange.To.Week),
        compareRangeFrom: buildWeeklyData(AvailableDates, CompareRange && CompareRange.From),
        compareRangeTo: buildWeeklyData(AvailableDates, CompareRange && CompareRange.To, CompareRange && CompareRange.To.Week),
        availableDates: AvailableDates,
        hasCompareRange: !!CompareRange,
        reset: function () { return init(); },
    }); };
    var _b = React.useReducer(reducer, init()), state = _b[0], dispatch = _b[1];
    return (React.createElement(PropsContext.Provider, { value: value },
        React.createElement(DispatchContext.Provider, { value: { dispatch: dispatch } },
            React.createElement(StateContext.Provider, { value: state }, children))));
};
exports.ChartRangeDropdownPickerProvider = ChartRangeDropdownPickerProvider;
function buildWeeklyData(availableDates, weekYear, MinSelectableDateNumber) {
    if (MinSelectableDateNumber === void 0) { MinSelectableDateNumber = 0; }
    if (weekYear) {
        var weeks = utils_1.getWeeksFromYear(availableDates, weekYear.Year);
        return {
            value: weeks.find(function (e) { return e.Week === weekYear.Week; }),
            weeks: weeks,
            year: weekYear.Year,
        };
    }
    return undefined;
}
exports.buildWeeklyData = buildWeeklyData;
function actionWeeklyDataSearch(state, currentData, search) {
    var weeks;
    if (search) {
        // we are searching
        weeks = utils_1.searchWeeksInYear(state.availableDates, currentData.year, search);
    }
    else {
        // with searching or cancelling the search
        weeks = utils_1.getWeeksFromYear(state.availableDates, currentData.year);
    }
    return {
        filter: search,
        weeks: weeks,
        year: currentData.year,
    };
}
function actionYearChange(state, year, value) {
    var weeks = utils_1.getWeeksFromYear(state.availableDates, year);
    return {
        value: Boolean(value) ? value : weeks[0],
        weeks: weeks,
        year: year,
    };
}
var ChangeToDate = function (ToDate, FromDate, which, item) {
    var toDate = (which === "From" ? ToDate : item).EndDate.valueOf();
    var fromDate = (which === "From" ? item : FromDate).EndDate.valueOf();
    var result = toDate < fromDate;
    return which === "From" ? result : !result;
};
